module.exports = __webpack_public_path__ + "media/images/sp/top/soudan_comment-01-5d79c811d1af9cb60bb2e2a540b59ef2.png";